import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-progress-timetable-item',
  templateUrl: './progress-timetable-item.component.html',
  styleUrls: ['./progress-timetable-item.component.scss'],
})
export class ProgressTimetableItemComponent {
  @Input() id: string;
  @Input() route;
  @Input() filename;
  @Input() started = false;
  @Input() progress = 0;
  @Input() completed = false;
  @Output() clickEvent = new EventEmitter<string>();

  clickComplete() {
    this.clickEvent.emit(this.id);
  }
}
